import { ActivityCompensationPayoutsList } from './activityCompensationPayouts/ActivityCompensationPayoutsList';
import { usePersonalSettings } from './PersonalSettingsContext';

export function PersonalSettingsActivityCompensationPayoutsList() {
    const { personalSettingsData } = usePersonalSettings();

    const organizationId = personalSettingsData?.organization.id;

    return <ActivityCompensationPayoutsList organizationId={organizationId} />;
}
